import { ChevronRight, Pencil } from 'lucide-react'
import { useEffect } from 'react'

import { Button } from 'slab'

function MemberQLEBanner ({
  qleSubtype,
}: {
  qleSubtype: string
}): React.ReactElement {
  useEffect(() => {
    window.segment?.page('[EE] QLE banner viewed', {
      qle_subtype: qleSubtype,
    })
  }, [qleSubtype])

  return (
    <div
      className='w-full p-4 mb-4'
      style={{
        border: '1px solid #7A26CF',
        borderRadius: '8px',
        background: 'linear-gradient(180deg, #F1E2FF -10.45%, #F9F4FF 12.98%, rgba(249, 244, 255, 0.00) 100%)',
      }}
    >
      <div className='flex flex-col xs:flex-row xs:items-center gap-4 justify-between'>
        <Pencil size={26} stroke='#4B1377' className='shrink-0' />
        <div className='text-gray-900 flex-grow'>
          Still want to change dependents or plans?
        </div>
        <div>
          <Button
            variant='secondary' size='small' width='auto'
            rightIcon={ChevronRight}
            onClick={() => {
              window.segment?.track('[EE] QLE banner clicked', {
                qle_subtype: qleSubtype,
              })
              window.open('/member_onboarding/progress?source=qle_banner', '_blank')
            }}
          >
            Continue where you left off
          </Button>
        </div>
      </div>
    </div>
  )
}

export default MemberQLEBanner
